import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import { c as classNames } from '../../shared/bind-737e5114.js';
import { getTestId } from '../../utils/testId.js';
import { idFromName } from '../../utils/html.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "toggle": "web_ui__Toggle__toggle",
  "button": "web_ui__Toggle__button",
  "label": "web_ui__Toggle__label",
  "inverse": "web_ui__Toggle__inverse"
};

var cssClasses = classNames.bind(styles);
var Toggle = function Toggle(props) {
  var name = props.name,
    text = props.text,
    checked = props.checked,
    _props$defaultChecked = props.defaultChecked,
    internalDefaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    disabled = props.disabled,
    inverse = props.inverse,
    onClick = props.onClick,
    onChange = props.onChange,
    aria = props.aria,
    testId = props.testId,
    forwardedRef = props.forwardedRef;
  var id = idFromName(name);
  return /*#__PURE__*/jsxs("label", {
    htmlFor: id,
    className: cssClasses(styles.toggle, {
      inverse: inverse
    }),
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({
      type: "checkbox",
      role: "switch",
      id: id,
      name: name,
      checked: checked
    }, checked === undefined && internalDefaultChecked && {
      defaultChecked: true
    }), {}, {
      disabled: disabled,
      onClick: onClick,
      onChange: onChange,
      "data-testid": getTestId(testId, 'input'),
      ref: forwardedRef
    }, aria)), /*#__PURE__*/jsx("span", {
      className: styles.button
    }), text ? /*#__PURE__*/jsx("span", {
      className: styles.label,
      "data-testid": getTestId(testId, 'text'),
      children: text
    }) : null]
  });
};

export { Toggle as default };
//# sourceMappingURL=Toggle.js.map
